var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.83203H5.5C3.97833 1.83203 2.75 3.0512 2.75 4.55453V14.5554C2.75 16.0587 3.97833 17.287 5.5 17.287H6.19667C6.92083 17.287 7.62667 17.5712 8.14 18.0845L9.7075 19.6337C10.4225 20.3395 11.5775 20.3395 12.2925 19.6337L13.86 18.0845C14.3733 17.5712 15.0792 17.287 15.8033 17.287H16.5C18.0217 17.287 19.25 16.0587 19.25 14.5554V4.55453C19.25 3.0512 18.0217 1.83203 16.5 1.83203ZM11 5.0862C11.99 5.0862 12.7875 5.89286 12.7875 6.8737C12.7875 7.84536 12.0175 8.62453 11.0642 8.6612C11.0275 8.6612 10.9725 8.6612 10.9267 8.6612C9.96417 8.62453 9.20333 7.84536 9.20333 6.8737C9.2125 5.89286 10.01 5.0862 11 5.0862ZM13.5208 13.4645C12.1367 14.3904 9.86333 14.3904 8.47917 13.4645C7.26 12.6579 7.26 11.3195 8.47917 10.5037C9.8725 9.57786 12.1458 9.57786 13.5208 10.5037C14.74 11.3195 14.74 12.6487 13.5208 13.4645Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTag);
export default __webpack_public_path__ + "static/media/user-tag.bcab5540e35ecd99f6862fd5c70c5ba3.svg";
export { ForwardRef as ReactComponent };